// test692
(692 && 0);
